import { MarriagePersonDetails } from "@/models"
import { css } from "vite-css-in-js"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useEditingMarriageClaimState } from "../state"
import { isEmptyStringOrNull } from "./utils"

const formSectionStyling = css`
	display: grid;
	align-items: center;
	grid-template-columns: repeat(2, 1fr);
	gap: 0.5rem 2rem;

	h6 {
		margin-bottom: 0;
	}

	@media (width < 992px) {
		grid-template-columns: 1fr;
	}
`

const PartnerInformation: ReactiveComponent = () => {
	const state = useEditingMarriageClaimState()

	return () =>
		Object.keys(state.fullClaim.PartnerDetails).filter(
			(key) => state.fullClaim.PartnerDetails[key as keyof MarriagePersonDetails] !== null
		).length === 0 ? (
			<h5>No Partner Information</h5>
		) : (
			<div class={formSectionStyling}>
				<div class="d-flex gap-1">
					<h6>Title:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.PartnerDetails.Title)
							? `Unknown`
							: state.fullClaim.PartnerDetails.Title}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Gender:</h6>
					<h6 class="fw-bold">{state.fullClaim.PartnerDetails.Gender ?? `Unknown`}</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>First Name:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.PartnerDetails.FirstName)
							? `Unknown`
							: state.fullClaim.PartnerDetails.FirstName}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Mobile Number:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.PartnerDetails.Mobile)
							? `Unknown`
							: state.fullClaim.PartnerDetails.Mobile}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Last Name:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.PartnerDetails.LastName)
							? `Unknown`
							: state.fullClaim.PartnerDetails.LastName}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>NI Number:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.PartnerDetails.NINumber)
							? `Unknown`
							: state.fullClaim.PartnerDetails.NINumber}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Email:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.PartnerDetails.Email)
							? `Unknown`
							: state.fullClaim.PartnerDetails.Email}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Birth Date:</h6>
					<h6 class="fw-bold">
						{state.fullClaim.PartnerDetails.BirthDate !== null
							? state.fullClaim.PartnerDetails.BirthDate.toGBString()
							: `Unknown`}
					</h6>
				</div>
			</div>
		)
}

export default defineComponent(PartnerInformation)
